import {
  Button,
  HeartIcon,
  HeartSolidIcon,
  Tooltip,
  TrashIcon
} from "@dealer-center/core-components";
import styled from "styled-components";
import type { AccountNames } from "@dealer-center/ddc-api-account-interface";
import { AccountLink } from "@dealer-center/ddc-core-custom-components";
import { useAccountFavourites } from "@dealer-center/ddc-api-account-fetch";

const StyledItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledAccountName = styled.span`
  flex-grow: 1;
`;
const StyledDeleteButton = styled(Button)`
  color: #dd2b2b;
  :hover {
    color: #c42525;
    background-color: transparent;
    border-color: transparent;
  }
`;
export function AccountListItem({
  account,
  onDelete,
  isLoadingAccountName,
  testId
}: {
  account: AccountNames;
  onDelete?: (account: string) => void;
  isLoadingAccountName?: boolean;
  testId?: string;
}) {
  const { accountFavorites, toggleAccountFavorites } = useAccountFavourites();
  const isFavourite = accountFavorites?.includes(account.accountId);
  if (!account || !account.accountId) {
    return null;
  }
  const htmlSafeAccount = account.accountId.replace(/[^a-zA-Z0-9]/g, "");
  const htmlIdPrefix = `${testId}-${htmlSafeAccount}`;
  return (
    <StyledItemContent>
      <StyledAccountName>
        <AccountLink
          accountID={account.accountId}
          accountName={account.accountName}
          component="client-search"
          isLoadingAccountName={isLoadingAccountName}
          testId={`${htmlIdPrefix}-account-link`}
        />
      </StyledAccountName>
      {onDelete && (
        <StyledDeleteButton
          analyticsConfiguration={{
            eventName: "Client Search Delete Account"
          }}
          buttonStyle="aux"
          data-testid={`${htmlIdPrefix}-delete`}
          icon={
            <Tooltip
              position="bottom"
              size="small"
              toolTipContent="Delete from history"
            >
              <TrashIcon title="Delete from history" />
            </Tooltip>
          }
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            onDelete(account.accountId);
          }}
        />
      )}
      <Button
        analyticsConfiguration={{
          eventName: "Client Search Favorite Account"
        }}
        buttonStyle="aux"
        data-testid={`${htmlIdPrefix}-favorite`}
        icon={
          isFavourite ? (
            <Tooltip
              position="bottom"
              size="small"
              toolTipContent="Remove favorite"
            >
              <HeartSolidIcon title="Remove favorite" />
            </Tooltip>
          ) : (
            <Tooltip
              position="bottom"
              size="small"
              toolTipContent="Add favorite"
            >
              <HeartIcon title="Add favorite" />
            </Tooltip>
          )
        }
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          toggleAccountFavorites(account.accountId);
        }}
      />
    </StyledItemContent>
  );
}
